import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  MDBTable,
  MDBBadge,
  MDBBtn,
  MDBRow,
  MDBIcon
} from 'mdb-react-ui-kit';
import PageHeader from '../../components/page/PageHeader';
import TableHeader from '../../components/table/TableHeader';
import TableBody from '../../components/table/TableBody';
import '../../components/MusButton.css';
import TorneoStore from '../../stores/TorneoStore';
import PageBody from '../../components/page/PageBody';
import MusUtils from '../../utils/Utilities';
import Confirmation from '../../components/Confirmation';

export default function ListadoTorneos() {
  const navigate = useNavigate();
  const [torneos, setTorneos] = useState(TorneoStore.getInstance().getAllTorneos());

  const [torneoSelected, setTorneoSelected] = useState();
  // let torneoSelected = "";
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [hiddeColumns, setHiddeColumns] = useState();
  const [hiddeColumnsBool, setHiddeColumnsBool] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  },[]);

  useEffect(() => {
    setHiddeColumns(window.innerWidth < 1023 ? 'none':'table-cell');
    setHiddeColumnsBool(window.innerWidth < 1023);
  });
  
  const saveTorneo = (item) => {
    TorneoStore.getInstance().saveTorneo(item);
    setTorneos(TorneoStore.getInstance().getAllTorneos());
    // setTorneoEditadoNum(-1);
  }

  const deleteTorneo = () => {
    TorneoStore.getInstance().deleteTorneo(torneoSelected);
    setTorneos(TorneoStore.getInstance().getAllTorneos());
    setShowConfirmation(false);
  }

  const iniciarContinuarTorneo = (torneoReceived) => {
    if (torneoReceived.status === "No Iniciado") {
      torneoReceived = MusUtils.resetRoundResults(torneoReceived);
    }
    torneoReceived.status = 'En Curso';
    saveTorneo(torneoReceived);
    navigate({pathname: '/gestionTorneo', search: `?torneoId=${torneoReceived.id}`});
  }

  const revisarTorneo = (torneoReceived) => {
    navigate({pathname: '/gestionTorneo', search: `?torneoId=${torneoReceived.id}`});
  }

  const cancelAction = () => {
    setShowConfirmation(false);
  }
  
  return (
      <>
        <PageHeader title="Torneos"></PageHeader>
        <PageBody>
          <Confirmation
                show={showConfirmation}
                setShow={setShowConfirmation}
                title="Confirmacion"
                message="Seguro que desea ELIMINAR el torneo?"
                cancelAction={cancelAction}
                aceptAction={deleteTorneo}
          ></Confirmation>
          <MDBRow>
            <div className='d-flex justify-content-end p-3'>
              <MDBBtn className='musButton-lg' onClick={()=>{ navigate({pathname: '/edicionTorneo', search: `?torneoId=-1`}) }} >
                <MDBIcon className='me-2' fas icon='address-card' /> Añadir Torneo
              </MDBBtn>
            </div>
          </MDBRow>
          <MDBTable striped align='middle'>
            <TableHeader>
              <tr>
                <th className='col-lg-3 col-md-7'>Nombre</th>
                <th className='col-lg-2 col-md-2'>Fecha</th>
                <th className='col-lg-1 col-md-0 text-center' style={{display: hiddeColumns}} >Parejas</th>
                <th className='col-lg-2 col-md-0 text-center' style={{display: hiddeColumns}} >Tipo Torneo</th>
                <th className='col-lg-2 col-md-2 text-center'>Estado</th>
                {/* <th className='col-lg-2 col-md-1 text-center'>Acciones</th> */}
                <th className='text-center' style={{width: hiddeColumnsBool ? '110px' : 'auto'}}>Acciones</th>
              </tr>
            </TableHeader>
            <TableBody>
              {torneos && torneos.map((item, index) => {
                // let torneoEditable = item.status !== 'No Iniciado';
                let dateFormat = new Date(item.date);
                return (
                  <>
                    <tr>
                      <td>
                        <span>{item.name}</span>               
                      </td>
                      <td>
                        <p className='text-muted mb-0'>{item.date ? dateFormat.getFullYear() + "-" + (dateFormat.getMonth()+1) + "-" +  dateFormat.getDate() + "" : ''}</p>
                      </td>
                      <td className='text-center' style={{display: hiddeColumns}} >
                        {item.doublets.length}
                      </td>
                      <td className='text-center' style={{display: hiddeColumns}} >
                        {item.championType}
                      </td>
                      <td className='text-center'>
                        <MDBBadge pill color={item.status === 'No Iniciado' ? 'success' : item.status ==='En Curso' ? 'warning' : item.status === 'Finalizado' ? 'danger' : 'danger'}>
                          {item.status}
                        </MDBBadge>
                      </td>
                      <td className='text-center'>
                        {/* {item.status === 'Finalizado' ? <></> : ( */}
                          <>
                            <MDBBtn className={hiddeColumnsBool ? 'musButton-sm-icon-table' : 'musButton-sm-table'} outline onClick={() => {navigate({pathname: '/edicionTorneo', search: `?torneoId=${item.id}`})} }>
                              <MDBIcon className={hiddeColumnsBool ? '' : 'me-2'} fas icon={item.status==='No Iniciado' ? 'edit' : 'address-card'} /> {hiddeColumnsBool ? '' : (item.status==='No Iniciado' ? 'Editar Torneo' : 'Revisar Torneo')}
                            </MDBBtn><br></br>
                          </>
                        {/* )} */}

                        <MDBBtn className={hiddeColumnsBool ? 'musButton-sm-icon-table' : 'musButton-sm-table'} outline onClick={()=>{setTorneoSelected(item.id);setShowConfirmation(true)}}>
                          <MDBIcon className={hiddeColumnsBool ? '' : 'me-2'} fas icon='trash' /> {hiddeColumnsBool ? '' : 'Eliminar Torneo'}
                        </MDBBtn><br></br>
                        {item.status === 'No Iniciado' ? (<>
                          <MDBBtn className={hiddeColumnsBool ? 'musButton-sm-icon-table' : 'musButton-sm-table'} outline onClick={()=>{iniciarContinuarTorneo(item)}} disabled={item.doublets.length < 2}>
                            <MDBIcon className={hiddeColumnsBool ? '' : 'me-2'} fas icon='play-circle' /> {hiddeColumnsBool ? '' : 'Iniciar Torneo'}
                          </MDBBtn></>
                        ) : item.status === 'En Curso' ? (
                          <MDBBtn className={hiddeColumnsBool ? 'musButton-sm-icon-table' : 'musButton-sm-table'} outline onClick={()=>{iniciarContinuarTorneo(item)}}>
                            <MDBIcon className={hiddeColumnsBool ? '' : 'me-2'} fas icon='play-circle' /> {hiddeColumnsBool ? '' : 'Continuar Torneo'}
                          </MDBBtn>
                        ) : item.status === 'Finalizado' ? 
                          <MDBBtn className={hiddeColumnsBool ? 'musButton-sm-icon-table' : 'musButton-sm-table'} outline onClick={()=>{revisarTorneo(item)}}>
                            <MDBIcon className={hiddeColumnsBool ? '' : 'me-2'} fas icon='stop-circle' /> {hiddeColumnsBool ? '' : 'Torneo Finalizdo'}
                          </MDBBtn> : <></>
                        }
                      </td>
                    </tr>
                  </>
                )
              })}
            </TableBody>
          </MDBTable>
        </PageBody>
      </>
  );
}
